import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-AccessSettings',
  templateUrl: './AccessSettings.component.html',
  styleUrls: ['./AccessSettings.component.scss']
})
export class AccessSettingsComponent implements OnInit {

  usermanagements!: any[];
  constructor(public router: Router, private toaster: ToastrService) { }

  ngOnInit(): void {
    this.usermanagements = [
      // tslint:disable-next-line:max-line-length
      {
        title: 'Manage Users',
        routerLink: this.getUserManager,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'Manage Roles',
        routerLink: this.getUserRole,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'Map Users with Roles',
        routerLink: this.getUserRoleMapping,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'Map Users with Machines',
        routerLink: this.getMachineMapping,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'View Licenses by Module',
        routerLink: this.getGroupLicense,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'Manage People Master Data',
        routerLink: this.getPeopleMasterDataMap,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      },
      {
        title: 'Manage Security Policy',
        routerLink: this.getAccessControl,
        icon: 'assets/images/manufacturing-admin.svg',
        disabled: false
      }
    ];
  }

  getUserManager = (): void => {
    this.router.navigate(['/Access/UserManager']);
  }
  getUserRole = (): void => {
    this.router.navigate(['/Access/RoleManager']);
  }
  getUserRoleMapping = (): void => {
    this.router.navigate(['/Access/RoleMap']);
  }
  getMachineMapping = (): void => {
    this.router.navigate(['/Access/MachineMap']);
  }
  getGroupLicense= (): void => {
    this.router.navigate(['/Home/GroupLicense']);
  }
  getPeopleMasterDataMap = (): void => {
    this.router.navigate(['/Access/PeopleMasterDataMap']);
  }
  getAccessControl = (): void => {
    this.router.navigate(['/Access/accesscontrol']);
  }

}
